import { Voni } from '../client';
import { PerformanceMetric, MetricsBatch } from '../types';

export interface SystemStatus {
  status: string;
  version: string;
  environment: string;
  timestamp: string;
  health?: Record<string, unknown>;
  authenticated_as?: string;
}


export class SystemResource {
  constructor(private client: Voni) { }

  async getStatus(): Promise<SystemStatus> {
    return this.client.request<SystemStatus>('GET', '/system/status');
  }

  async postMetrics(metrics: PerformanceMetric[]): Promise<void> {
    await this.client.request('POST', '/system/metrics', undefined, { metrics });
  }
}
